import { createSelector } from '@ngrx/store';
import { AppState } from 'src/app/store/app.reducer';

export const selectSiteState = (state: AppState) =>
  state.site;


export const selectSites = createSelector(
  selectSiteState,
  (state) => state.sites
);
export const selectTransferLoading = createSelector(
  selectSiteState,
  (state) => state.transferLoading
);
export const selectTransfers = createSelector(
  selectSiteState,
  (state) => state.transfers
);
export const selectTransferred = createSelector(
  selectSiteState,
  (state) => state.transferred
);
export const selectAddEditSuccess = createSelector(
  selectSiteState,
  (state) => state.addEditSuccess
);
export const selectCurrentSite = createSelector(
    selectSiteState,
    (state) => state.currentSite
);
export const selectSitesLoading = createSelector(
    selectSiteState,
    (state) => state.sitesLoading
);
export const selectSitesEmpty = createSelector(
    selectSiteState,
    (state) => state.sitesEmpty
);
export const selectSiteDeleted = createSelector(
    selectSiteState,
    (state) => state.deleted
);
export const selectSitesOnlineDevices= createSelector(
  selectSiteState,
  (state) => state.sitesOnlineDevices
);